<template>
  <div>
    <popup-add-product
      v-if="productSpec"
      ref="popupAddProduct"
      :existingProducts="productSpec.stockProductSpecItems"
      :totalVenueStock="stockProducts"
      @productSelected="addNewProduct"
    />
    <popup-add-category
      v-if="productSpec"
      ref="popupAddCategory"
      :existingCategories="productSpec.productCategorySpecItems"
      @categorySelected="addNewCategory"
    />
    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      max-items="100"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isActive"
    >
      <div
        class="mt-6 flex items-center justify-between px-6"
        v-if="productSpec"
      >
        <div class="flex items-center">
          <img
            v-if="productSpec.imageUrl && productSpec.imageUrl !== ''"
            width="40"
            :src="productSpec.imageUrl"
            class="mr-4"
          />
          <img v-else width="40" :src="ProductIcon" class="mr-4" />
          <div>
            <h4>Product recipe</h4>
            <small v-if="orgProductSpec"
              >Created by {{ orgProductSpec.createdBy.username }}</small
            >
          </div>
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="isActive = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <Loading v-if="isLoading" />
        <div v-else class="p-6">
          <p class="mb-3 font-bold">Details</p>

          <vs-row>
            <vs-col vs-w="6">
              <div v-if="!isEditingDetails">
                <vs-row class="mb-2">
                  <h3 class="spec-name">{{ productSpec.name }}</h3>
                  <feather-icon
                    class="cursor-pointer ml-4"
                    icon="EditIcon"
                    svgClasses="w-5 h-5"
                    @click="isEditingDetails = true"
                  />
                </vs-row>
                <img
                  :src="productSpec.imageUrl"
                  height="140px"
                  class="rounded-lg"
                />
              </div>
              <div v-else class="mr-5">
                <div class="flex flex-col mb-3">
                  <div class="mb-1 text-sm">
                    <span>Recipe name</span>
                  </div>
                  <div>
                    <vs-input class="w-full" v-model="productSpec.name" />
                  </div>
                </div>

                <div class="flex flex-col mb-3">
                  <div class="mb-1 text-sm">
                    <span>Image url</span>
                  </div>
                  <div>
                    <vs-input class="w-full" v-model="productSpec.imageUrl" />
                  </div>
                </div>

                <div class="flex justify-end">
                  <vs-button
                    type="border"
                    icon="icon-check-circle"
                    icon-pack="feather"
                    @click="isEditingDetails = false"
                    >Save details</vs-button
                  >
                </div>
              </div>
            </vs-col>
            <vs-col vs-w="6" v-if="orgProductSpec">
              <div>
                <vs-row class="mb-1 text-sm">
                  <span>Created by</span>
                </vs-row>
                <vs-row>
                  <code
                    >{{ orgProductSpec.createdBy.username }} at
                    {{ orgProductSpec.createdAt | formatDate }}</code
                  >
                </vs-row>
              </div>
              <div v-if="orgProductSpec.updatedBy" class="mt-2">
                <vs-row class="mb-1 text-sm">
                  <span>Updated by</span>
                </vs-row>
                <vs-row>
                  <code
                    >{{ orgProductSpec.updatedBy.username }} at
                    {{ orgProductSpec.updatedAt | formatDate }}</code
                  >
                </vs-row>
              </div>
            </vs-col>
          </vs-row>

          <vs-divider />

          <p class="mb-3 font-bold">Recipe</p>

          <div class="recipe-table data-list-list-view">
            <vs-table :data="mappedItems">
              <template slot="thead">
                <vs-th>Type</vs-th>
                <vs-th sort-key="name">Name</vs-th>
                <vs-th sort-key="amount">Amount</vs-th>
                <vs-th></vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                    <vs-td>
                      <div
                        class="
                          product-name
                          font-medium
                          truncate
                          flex flex-row
                          items-center
                        "
                      >
                        <img
                          v-if="tr.type == 'product'"
                          width="40"
                          :src="ProductIcon"
                        />
                        <img v-else width="40" :src="CategoryIcon" />
                        <span class="ml-2">{{
                          tr.type == "product" ? "Product" : "Category"
                        }}</span>
                      </div>
                    </vs-td>
                    <vs-td>
                      <div>
                        {{ tr.name }}
                      </div>
                    </vs-td>
                    <vs-td>
                      <div class="flex items-center">
                        <div class="flex inline-block">
                          <vs-input-number
                            :min="0"
                            :step="1"
                            :value="tr.amount"
                            @input="(e) => onChangedAmount(tr, e)"
                          />
                        </div>
                        <div class="ml-2">
                          <vs-select
                            width="60px"
                            :value="tr.unit"
                            @input="(e) => onChangedUnit(tr, e)"
                          >
                            <vs-select-item key="cl" value="cl" text="cl" />
                          </vs-select>
                          <!-- {{ tr.unit }} -->
                        </div>
                      </div>
                    </vs-td>
                    <!-- <vs-td>
                      <feather-icon
                        icon="EditIcon"
                        svgClasses="w-5 h-5 hover:text-success stroke-current"
                      />
                    </vs-td> -->
                    <vs-td class="whitespace-no-wrap">
                      <feather-icon
                        icon="TrashIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        @click.stop="removeItem(tr)"
                      />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
          <div class="flex justify-end mt-2">
            <vs-button type="border" @click="$refs.popupAddProduct.show()">
              <feather-icon icon="PlusIcon" svgClasses="w-4 h-4" />
              <span class="ml-1">Add product</span>
            </vs-button>
            <vs-button
              type="border"
              class="ml-4"
              @click="$refs.popupAddCategory.show()"
            >
              <feather-icon icon="PlusIcon" svgClasses="w-4 h-4" />
              <span class="ml-1">Add category</span>
            </vs-button>
          </div>

          <vs-divider />

          <p class="mb-3 font-bold">Recipe info</p>

          <div class="flex space-between mt-5">
            <vs-col vs-w="6" class="ml-5">
              <vs-col vs-w="6">
                <b>Number of items in recipe: </b>
              </vs-col>
              <vs-col vs-w="6">
                <span>{{ mappedItems.length }}</span>
              </vs-col>
              <vs-col vs-w="6">
                <b>Total recipe amount: </b>
              </vs-col>
              <vs-col vs-w="6">
                <span>{{ totalAmount }} cl</span>
              </vs-col>

              <div></div>
            </vs-col>
            <vs-col vs-w="6">
              <div id="chart">
                <VueApexCharts
                  type="pie"
                  width="400"
                  :options="chartOptions"
                  :series="series"
                ></VueApexCharts>
              </div>
            </vs-col>
          </div>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button
          class="mr-6"
          @click="create"
          :disabled="!isFormValid"
          v-if="isNew"
        >
          Create
        </vs-button>
        <vs-button
          class="mr-6"
          @click="save"
          :disabled="!isFormValid"
          v-if="!isNew"
        >
          Save
        </vs-button>
        <!-- <vs-button v-if="!isNew" color="danger" @click="confirmDelete">
          Delete</vs-button
        > -->
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/product-icon.png";
import CategoryIcon from "@/assets/images/storage_icon.png";
import PopupAddProduct from "./PopupAddProduct.vue";
import PopupAddCategory from "./PopupAddCategory.vue";
import { mapGetters } from "vuex";
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    VuePerfectScrollbar,
    PopupAddProduct,
    PopupAddCategory,
    VueApexCharts,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      ProductIcon,
      CategoryIcon,

      isActive: false,
      isLoading: true,

      isNew: false,
      productSpec: null,
      orgProductSpec: null,

      isEditingDetails: false,
    };
  },
  computed: {
    ...mapGetters({
      stockProducts: "stockProducts/stockProducts",
      productCategories: "productCategories/productCategories",
    }),
    chartOptions() {
      let labels = this.mappedItems.map((item) => {
        // Cut name length to a maximum of 15
        let name = item.name;
        if (name.length > 15) {
          name = name.substring(0, 15) + "...";
        }
        return name;
      });

      return {
        chart: {
          width: 400,
          type: "pie",
        },
        colors: [
          "#17312D",
          "#E6BD71",
          "#4ecdc4",
          "#ff6b6b",
          "#7272ab",
          "#dddbf1",
          "#592941",
          "#52b788",
        ],
        labels,
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    },
    series() {
      // TODO unit calculation
      return this.mappedItems.map((item) => {
        return parseFloat(item.amount);
      });
    },
    totalAmount() {
      // TODO unit calculation
      return this.mappedItems.reduce((acc, item) => {
        return acc + parseFloat(item.amount);
      }, 0);
    },
    isFormValid() {
      return true;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    mappedItems() {
      if (!this.productSpec) return [];

      let products = this.productSpec.stockProductSpecItems.map((item) => {
        return {
          type: "product",
          id: item.stockProductId.id,
          name: item.name,
          amount: item.quantity.amount,
          unit: item.quantity.unit,
        };
      });

      let categories = this.productSpec.productCategorySpecItems.map((item) => {
        return {
          type: "category",
          id: item.productCategoryId.id,
          name: item.name,
          amount: item.quantity.amount,
          unit: item.quantity.unit,
        };
      });

      return [...products, ...categories];
    },
  },
  methods: {
    onChangedAmount(item, value) {
      if (item.type == "product")
        this.productSpec.stockProductSpecItems.find(
          (x) => x.stockProductId.id == item.id
        ).quantity.amount = value;
      else
        this.productSpec.productCategorySpecItems.find(
          (x) => x.productCategoryId.id == item.id
        ).quantity.amount = value;
    },
    onChangedUnit(item, value) {
      if (item.type == "product")
        this.productSpec.stockProductSpecItems.find(
          (x) => x.stockProductId.id == item.id
        ).quantity.unit = value;
      else
        this.productSpec.productCategorySpecItems.find(
          (x) => x.productCategoryId.id == item.id
        ).quantity.unit = value;
    },
    removeItem(item) {
      if (item.type == "product")
        this.productSpec.stockProductSpecItems =
          this.productSpec.stockProductSpecItems.filter(
            (x) => x.stockProductId.id != item.id
          );
      else
        this.productSpec.productCategorySpecItems =
          this.productSpec.productCategorySpecItems.filter(
            (x) => x.productCategoryId.id != item.id
          );
    },
    async showEmpty() {
      this.orgProductSpec = null;
      this.productSpec = {
        name: "Your recipe",
        imageUrl:
          "https://d2csxpduxe849s.cloudfront.net/media/6D937754-ECFA-4FEC-AB521EB00F52D221/34F73580-C2D0-48BD-9935F5422DD7DAAF/webimage-AB459A64-4F8F-4C7E-8914D9D1A76F1F9D.png",
        stockProductSpecItems: [],
        productCategorySpecItems: [],
      };

      this.isActive = true;
      this.isLoading = true;
      this.isNew = true;

      await this.loadExternalData();
      this.isLoading = false;
    },
    async show(productSpecId) {
      this.isActive = true;
      this.isLoading = true;
      this.isNew = false;

      var result = await this.$store.dispatch(
        "productSpecs/getProductSpec",
        productSpecId
      );

      this.orgProductSpec = result;
      this.productSpec = {
        name: result.name,
        imageUrl: result.imageUrl,
        stockProductSpecItems: result.stockProductSpecItems,
        productCategorySpecItems: result.productCategorySpecItems,
      };

      await this.loadExternalData();
      console.log("Got product spec", this.productSpec);
      this.isLoading = false;
    },

    async loadExternalData() {
      await this.$store.dispatch("stockProducts/getStockProducts", {
        take: 100000,
        skip: 0,
      });
      await this.$store.dispatch("productCategories/getProductCategories");
    },

    addNewProduct(productId) {
      let product = this.stockProducts.find((p) => p.id == productId);

      this.productSpec.stockProductSpecItems.push({
        stockProductId: {
          id: product.id,
        },
        name: product.name,
        quantity: {
          amount: 1,
          unit: "cl",
        },
      });
    },

    addNewCategory(categoryId) {
      let category = this.productCategories.find(
        (p) => p.productCategoryId.id == categoryId
      );

      this.productSpec.productCategorySpecItems.push({
        productCategoryId: {
          id: category.productCategoryId.id,
        },
        name: category.name,
        quantity: {
          amount: 1,
          unit: "cl",
        },
      });
    },

    confirmDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Delete this product recipe?`,
        accept: this.deleteSchema,
      });
    },
    async deleteSchema() {
      // await this.$store.dispatch(
      //   "productSpec/deleteStockingTemplate",
      //   this.orgStockingTemplate.id
      // );

      this.$vs.notify({
        title: "Product recipe deleted",
        text: "Your product recipe has been deleted.",
      });

      this.isActive = false;
      this.isLoading = true;
    },
    async save() {
      console.log("Saving DTO", this.productSpec);

      this.productSpec.id = this.orgProductSpec.id;

      const dto = {
        name: this.productSpec.name,
        imageUrl: this.productSpec.imageUrl,
        stockProductSpecItemIds: this.productSpec.stockProductSpecItems.map(
          (x) => ({
            stockProductId: x.stockProductId.id,
            unit: x.quantity.unit,
            amount: x.quantity.amount,
          })
        ),
        productCategorySpecItemIds:
          this.productSpec.productCategorySpecItems.map((x) => ({
            productCategoryId: x.productCategoryId.id,
            unit: x.quantity.unit,
            amount: x.quantity.amount,
          })),
      };

      const result = await this.$store.dispatch(
        "productSpecs/updateProductSpec",
        {
          id: this.orgProductSpec.id,
          dto,
        }
      );

      this.$vs.notify({
        title: "Product recipe saved",
        text: "Your product recipe has been saved.",
      });

      this.isActive = false;
      this.isLoading = true;
    },
    async create() {
      console.log("Creating DTO", this.productSpec);

      const dto = {
        name: this.productSpec.name,
        imageUrl: this.productSpec.imageUrl,
        stockProductSpecItems: this.productSpec.stockProductSpecItems.map(
          (x) => ({
            stockProductId: x.stockProductId.id,
            unit: x.quantity.unit,
            amount: x.quantity.amount,
          })
        ),
        productCategorySpecItems: this.productSpec.productCategorySpecItems.map(
          (x) => ({
            productCategoryId: x.productCategoryId.id,
            unit: x.quantity.unit,
            amount: x.quantity.amount,
          })
        ),
      };

      const result = await this.$store.dispatch(
        "productSpecs/createProductSpec",
        dto
      );

      this.$vs.notify({
        title: "Product recipe created",
        text: "Your product recipe has been created.",
      });

      this.isActive = false;
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss">
.recipe-table {
  .vs-table--thead tr {
    color: white;
  }

  .vs-con-tbody {
    background-color: rgba(var(--vs-primary)) !important;
    border-radius: 8px;
  }
}
</style>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 920px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.spec-name {
  font-family: HelNeue;
  letter-spacing: 0.05em;
}
</style>